import React, { useEffect, useState } from "react";
import styles from "./profileComp.module.scss";
import { useProfile } from "../../../../context/ProfileContext";
import Icon from "../../../../components/Icon";
import { education } from "../../types";

const Education = () => {
  const {
    profileInfo,
    handleFocus,
    current,
    handleSubmit,
    setProfileInfo,
    handleDiscardData,
    handleDiscard,
  } = useProfile();
  const [focus, setFocus] = useState<number | null>(null);

  const handleEducation = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { name, value } = e.target;

    setProfileInfo((prev: any) => ({
      ...prev,
      educationalQualifications: [
        ...prev.educationalQualifications?.map((item: education, i: number) => {
          if (i === index) {
            return {
              ...item,
              [name]: name === "startDate" || name === "endDate" ? yyyyMmDd(value) : value,
            };
          }
          return item;
        }),
      ],
    }));
  };

  const addEducation = () => {
    let data = {
      level: "",
      institution: "",
      fieldOfStudy: "",
      endDate: "",
      startDate: "",
    };

    setProfileInfo((prev: any) => ({
      ...prev,
      educationalQualifications: [...prev.educationalQualifications, data],
    }));
  };

  const ddMmYyyy = (date: string) => {
    const [d, m, year] = date.split("-");
    return `${year}-${m}-${d}`;
  };

  const yyyyMmDd = (date: string) => {
    const [year, m, d] = date.split("-");
    return `${d}-${m}-${year}`;
  };

  return (
    <div
      className={`${current?.section === "education" ? `${styles.editing} ` : null} ${
        styles.InfoContainer
      }`}
    >
      <div className={styles.Header}>
        <h3>Education</h3>
        <div className={styles.actions}>
          {current?.section === "education" && (
            <div className={styles.headerStatus}>
              <Icon name="edit" width={15} height={15} className={styles.edits} />
              <p>editing</p>
            </div>
          )}
          <div onClick={addEducation}>
            <Icon name="add" width={15} height={15} className={styles.edits} />
          </div>
        </div>
      </div>

      <div>
        {profileInfo?.educationalQualifications?.map((item, index) => (
          <div key={index} className={`${styles.boxInp}`}>
            {Object.keys(item).map((key) => {
              return (
                <div key={key} className={styles.contBoxes}>
                  <label htmlFor={key} className={styles.labels}>
                    {key === "level"
                      ? "Degree"
                      : key === "startDate"
                      ? "Start Date"
                      : key === "endDate"
                      ? "End Date"
                      : key === "institution"
                      ? "Institution"
                      : key === "fieldOfStudy"
                      ? "Field Of Study"
                      : key}
                  </label>
                  <div className={`${styles.inputContainer}`}>
                    <input
                      type={key === "endDate" || key === "startDate" ? "date" : "text"}
                      name={key}
                      value={
                        key === "endDate" || key === "startDate"
                          ? ddMmYyyy(item[key as keyof education])
                          : item[key as keyof education]
                      }
                      className={`${styles.basicInputs}`}
                      placeholder={
                        key === "level"
                          ? "Degree"
                          : key === "startDate"
                          ? "Start Date"
                          : key === "endDate"
                          ? "End Date"
                          : key === "institution"
                          ? "Institution"
                          : key === "fieldOfStudy"
                          ? "Field Of Study"
                          : key
                      }
                      onChange={(e) => handleEducation(e, index)}
                      onFocus={() => {
                        handleFocus(key, "education", index);
                        handleDiscardData("educationalQualifications");
                        setFocus(index);
                      }}
                    />

                    <div>
                      {key !== "endDate" && key !== "startDate" && (
                        <Icon name="edit" width={20} height={20} className={styles.edits} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            {focus === index && (
              <div className={styles.saves}>
                <button
                  className={styles.save}
                  onClick={(e: any) => handleSubmit(e, "educationalQualifications")}
                >
                  Save
                </button>
                <button
                  className={styles.discard}
                  onClick={() => handleDiscard("educationalQualifications")}
                >
                  Discard
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;
